export default __webpack_public_path__ + "static/media/drawing-man4-focusfill.cc556281.svg";